export const environment = {
  production: true,
  api: 'https://staging-api.bitscan.net/api/v1',
  // queue_url: 'https://staging-api-queue.bitscan.net/api/queue',
  queue_url: 'https://staging-queue-dev.bitscan.net/api/queue/',
  queue_key: 'bkbeats'
};
